// START Change cart promo header for mobile
if($(window).width() < 568) {
   console.log($(window).width());
    $(".cart-promo-header-img").each(function() {
      
      $(this).attr("src", "https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_Gallery-Cart-Assets_20260619-03.jpg?v=1781831930"); 
                });
            } else if ($(window).width() >= 568) {
                
                $(".cart-promo-header-img").each(function() {
                $(this).attr("src","https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_Gallery-Cart-Assets_20260619-02.jpg?v=1781831930");

                });                        
    };
// END Change logo for mobile